var map = {
	"./discord.svg": 71621,
	"./facebook.svg": 71767,
	"./gamepedia.svg": 19915,
	"./instagram.svg": 12155,
	"./kickstarter.svg": 56169,
	"./login/amazon.svg": 62902,
	"./login/apple.svg": 84628,
	"./login/baidu.svg": 2901,
	"./login/battlenet.svg": 43520,
	"./login/discord.svg": 30971,
	"./login/epicgames.svg": 24697,
	"./login/facebook.svg": 9921,
	"./login/github.svg": 9429,
	"./login/google.svg": 25096,
	"./login/kakao.svg": 66726,
	"./login/linkedin.svg": 94918,
	"./login/mailru.svg": 81028,
	"./login/microsoft.svg": 45415,
	"./login/msn.svg": 70546,
	"./login/naver.svg": 59205,
	"./login/ok.svg": 81102,
	"./login/paypal.svg": 56329,
	"./login/qq.svg": 41842,
	"./login/reddit.svg": 80335,
	"./login/steam.svg": 99139,
	"./login/three-dots.svg": 32667,
	"./login/twitch.svg": 25599,
	"./login/twitter.svg": 16254,
	"./login/vimeo.svg": 54080,
	"./login/vk.svg": 4612,
	"./login/wechat.svg": 25229,
	"./login/weibo.svg": 99263,
	"./login/xbox.svg": 41022,
	"./login/yahoo.svg": 52804,
	"./login/yandex.svg": 8033,
	"./login/youtube.svg": 11477,
	"./twitch.svg": 82823,
	"./twitter.svg": 12653,
	"./vk.svg": 70668,
	"./wechat.svg": 95180,
	"./youtube.svg": 19352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52263;